import React from "react";
import { connect } from "react-redux";
import { authentication } from "../app-database";
import { validarLiga } from "./servicios.act";

import { goTo } from "../tools";
import LigaExpiro from "./ligaExpiro.cmpt";
import ErrorGeneral from "./errorGeneral.cmpt";
import Seguridad from "./seguridad.cmpt";
import Exito from "./exito.cmpt";
import LoSentimos from "./loSentimos.cmpt";
import Contrato from "./contrato.cmpt";
import Confidencialidad from "./confidencialidad.cmpt";

const mapState = (state) => {
	return {
		loader: state.global.loader,
		paso: state.recuperar.paso
	};
};

const mapDispatch = (dispatch) => {
	return {
		showLoad: () => {
			dispatch({ "type": "LOADER_SHOW"});
		},
		alerta: (sTitulo, sMensaje, fnCerrar) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": sTitulo, "mensaje": sMensaje, "accion": fnCerrar });
		},
		validarLiga: (uid,time,status) => {
			dispatch(validarLiga(uid,time,status));
		}
	};
};

class Flujo extends React.Component {
	
	componentWillMount = () => {
		this.props.showLoad();
		
		if(this.props.hashOne && this.props.hashOne != "" && this.props.hashTwo && this.props.hashTwo != "" && this.props.hashThree && this.props.hashThree != "") {
			this.props.validarLiga(this.props.hashOne, this.props.hashTwo, this.props.hashThree);
		} else {
			this.props.alerta("ERROR", "La liga no puede ser procesada", () => { 
				goTo("login");
			});
		}
	}
	
	render() {
		return (
			<div className="content-wrap">
				<div className="container">
					<div className="ayuda-wrap">
						<p>¿Tienes duda de cómo utilizar el portal? <a href="">Ver tutorial</a></p>
					</div>
					<div className="white-box">
						{ !this.props.loader && this.props.paso == "formm" && 
							<Seguridad tipo="m" />
						}
						{ !this.props.loader && this.props.paso == "formnm" &&
							<Seguridad tipo="nm" />
						}
						{ !this.props.loader && this.props.paso == "expiro" && 
							<LigaExpiro />
						}
						{ !this.props.loader && this.props.paso == "error" && 
							<ErrorGeneral />
						}
						{ !this.props.loader && this.props.paso == "losentimos" &&
							<LoSentimos />
						}
						{ !this.props.loader && this.props.paso == "contrato" &&
							<Contrato />
						}
						{ !this.props.loader && this.props.paso == "confidencialidad" &&
							<Confidencialidad />
						}
						{ !this.props.loader && this.props.paso == "exito" && 
							<Exito />
						}
					</div>
				</div>
			</div>            
		)
	}
}

export default connect(mapState, mapDispatch)(Flujo);


// WEBPACK FOOTER //
// ./src/recuperar-contrasenia/flujo.cmpt.js